import React, {type JSX} from 'react';
import HealthConnectModule from './app/guestportal';

function App(): JSX.Element {
  return <HealthConnectModule />;
}

export default App;
